<div class="header" layout layout-align-items-center>
  <rt-badge color="ai" [text]="'app.common.ai' | translate" class="badge" />
  <rt-heading>
    {{ 'app.evaluation_insights.tooltip.quick_analysis_heading' | translate }}
  </rt-heading>
</div>
<div class="content" margin-top-medium>
  {{ insightQuickContent() }}
</div>
